import React from 'react';
import { CheckIcon } from 'lucide-react';
import { addOns } from '../data/content';
import { HeroReel } from './HeroReel';
const included = ["A dedicated coach located in Austin, TX", "Sessions on video, scheduled around class and work shifts", "Actionable tools and feedback", 'Async messaging when something urgent comes up'];
export function Coaching() {
  return <section id="coaching" className="bg-pearl-50 py-14 dark:bg-slate-950 sm:py-20" data-id="element-44" data-mp="jv6okry2r5cf">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-45" data-mp="3saqbzac2dtjk">
        <div className="max-w-2xl" data-id="element-46" data-mp="3naaxugjyki0j">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-47" data-mp="3nbdpwrt0oqi1">
            MEET YOUR COACH & UNDERSTAND THE PLAN
          </p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" style={{
          fontSize: "32px"
        }} data-id="element-48" data-mp="41xorcv06nf">
            One coach and a customized plan. 
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 dark:text-slate-300 sm:text-lg" data-id="element-49" data-mp="1bm33dy3p3k2c">
            From early career to management, Emberly Johnston founded Early Edge Coaching after years of corporate campus recruiting and managing early talent programs. Through her passion and expertise, Emberly designs development plans that enable students to discover their personal brand and confidence. 
          </p>
        </div>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 sm:gap-x-10" data-id="element-50" data-mp="39bwp4ryyfip1">
          {included.map(item => <li key={item} className="flex gap-3 text-slate-700 dark:text-slate-200" data-id="element-51" data-mp="3e9y9rhc13q2m">
              <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-butter-200 text-butter-700 dark:bg-butter-500/30 dark:text-butter-300" data-id="element-52" data-mp="3j9kknk4dwu89">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="3o242ita3ubiv" />
              </span>
              <span className="leading-relaxed" data-id="element-54" data-mp="2qisrywmj2npo">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex items-stretch gap-5 border-t border-slate-200 pt-8 dark:border-slate-800 sm:gap-8" data-id="element-55" data-mp="2vi5e1f5krqr7">
          <div className="w-[46%] max-w-[16rem] flex-none sm:w-[34%]" data-id="element-56" data-mp="2jhozyt0fo2mk">
            <HeroReel data-id="element-57" data-mp="2jhgmp00eevau" />
          </div>

          <div className="flex min-w-0 flex-1 flex-col" data-id="element-58" data-mp="2x8u2q3z3lb14">
            <p className="text-sm font-semibold text-slate-800 dark:text-pearl-100" data-id="element-59" data-mp="2x8byol671sin">
              Or grab just one thing:
            </p>
            <ul className="mt-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap" data-id="element-60" data-mp="24k6d5w7bfzhr">
              {addOns.map(addOn => <li key={addOn.name} className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs leading-snug text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 sm:w-auto sm:text-sm" data-id="element-61" data-mp="20j4d5d5krjeq">
                  {addOn.name}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}